exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Messages-module__wrapper___3UyTZ{position:absolute;background-color:#fff;box-shadow:0 0 17.5px rgba(0,0,0,.08);top:80px;right:1.5rem;width:360px;padding:1rem;border-radius:7px;display:grid;gap:1rem}.Messages-module__wrapper___3UyTZ .Messages-module__no-content___11kyv{text-align:center;display:grid;gap:.5rem;justify-content:center}.Messages-module__wrapper___3UyTZ .Messages-module__no-content___11kyv img{margin:0 auto}", ""]);

// exports
exports.locals = {
	"wrapper": "Messages-module__wrapper___3UyTZ",
	"no-content": "Messages-module__no-content___11kyv"
};